import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./normalize.scss";
import "./theme/base.scss";
import "react-simple-keyboard/build/css/index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

reportWebVitals();
